export default __webpack_public_path__ + "static/media/insertion.c6ced943.JPG";